import sessionstore from './storage/sessionstore';
import cookiestore from './storage/cookiestore';
import localstore from './storage/localstore';

const Storage = function(storageType) {
  const storageTypes = {
    cookie: cookiestore,
    local: localstore,
    localStorage: localstore,
    session: sessionstore,
  }

  return storageType => storageTypes[storageType];
}

export default Storage;
